import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';

import { IBtrStaticPageApiModel } from '@app/core/models/api/btr-static-page.api.model';
import { BtrStaticPageModel } from '@app/core/models/btr-static-page.model';

@Injectable()
export class BtrStaticPageApiService {
  constructor(private http: HttpClient) {}

  public getStaticPages(): Observable<Array<BtrStaticPageModel>> {
    return this.http
      .get<Array<IBtrStaticPageApiModel>>(
        `${environment.API_URL}v5/static.pages.json`,
      )
      .pipe(map(res => res.map(item => new BtrStaticPageModel(item))));
  }

  public getStaticPage(req: { slug: string }): Observable<BtrStaticPageModel> {
    let params = new HttpParams({ fromObject: req });
    return this.http
      .get<IBtrStaticPageApiModel>(
        `${environment.API_URL}v5/static.page.json`,
        { params },
      )
      .pipe(map(item => new BtrStaticPageModel(item)));
  }
}
